import React from 'react';

import { OrderDirection, WorkbookOrderField } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';

export type WorkbooksValidSortFields =
  WorkbookOrderField.NAME |
  WorkbookOrderField.SHEETS_COUNT |
  WorkbookOrderField.PROJECT_NAME |
  WorkbookOrderField.CONTAINER_NAME;

export const WorkbooksDefaultDirections: DefaultDirections<WorkbooksValidSortFields> = {
  [WorkbookOrderField.NAME]: OrderDirection.ASC,
  [WorkbookOrderField.SHEETS_COUNT]: OrderDirection.DESC,
  [WorkbookOrderField.PROJECT_NAME]: OrderDirection.ASC,
  [WorkbookOrderField.CONTAINER_NAME]: OrderDirection.ASC,
};

export const WorkbooksDefaultSortField = WorkbookOrderField.NAME;

export function WorkbooksGridSortProvider(
  props: Pick<SortProviderProps<WorkbooksValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<WorkbooksValidSortFields>
      validOrderFieldsWithDefaultDirections={WorkbooksDefaultDirections}
      defaultField={WorkbooksDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
